import { Input as ChakraInput } from '@chakra-ui/react';
import { forwardRef } from 'react';
import type { StyleProps } from '../../../types';
import { popFieldWrapperProps } from '../../../utils';
import { FieldWrapper } from '../FieldWrapper';

import { InputDefaultProps, type InputProps } from './Input.types';

const Input = forwardRef<HTMLInputElement, InputProps>(({ variant, id, ...props }, ref) => {
  const { poppedProps, otherProps } = popFieldWrapperProps(props);
  const styles = variant === 'flushed' ? FlushedStyles : InputStyles;

  return (
    <FieldWrapper {...poppedProps} id={id}>
      <ChakraInput ref={ref} id={id} variant={variant} {...styles} {...otherProps} />
    </FieldWrapper>
  );
});

const InputStyles: StyleProps = {
  borderColor: 'border',
  bg: 'bg',
};

const FlushedStyles: StyleProps = {
  borderColor: 'border',
};

Input.displayName = 'Input';
Input.defaultProps = InputDefaultProps;

export { Input };
